import { ActionType, Action, TransactionDisplayType } from './types'

export const updateTransactionDisplayType = (
  displayType: TransactionDisplayType
): Action => ({
  type: ActionType.UpdateTransactionDisplayType,
  displayType,
})
